<template>

<div class="panel" :class="{'is-session': $route.meta.isSession, 'is-show': show}" v-bind:style="{'marginLeft': window.menuIndentContent}">

    <com-context v-if="$route.meta.isProfile" :is-minimised="window.menuMinimised" />
    <com-session v-if="$route.meta.isSession" :is-minimised="window.menuMinimised" />
    <com-bgg v-if="$route.meta.isBGG" :is-minimised="window.menuMinimised" />

    <com-menu :is-minimised="window.menuMinimised" />

    <div class="links" v-if="!$route.meta.isSession">

		<div class="links-item is-bgg"><small>raw data from</small> <a target="_blank" href="https://www.boardgamegeek.com">boardgamegeek.com</a></div>

	</div>

</div>

</template>

<script>

import comContext from './panel/Context'
import comSession from './panel/Session'
import comBGG from './panel/BGG'
import comMenu from './panel/Menu'

export default {

	props: ['show'],

    components: {
        'com-bgg': comBGG,
        'com-context': comContext,
        'com-session': comSession,
        'com-menu': comMenu
    },

	computed: {

		hasLinks: function() {

			return false

		}

	},

	methods: {

		onPageClick: function(name, e) {

			e.stopPropagation()

			this.$pubsub.$emit('open.modal', name)

		}

	}

}

</script>

<style scoped>

.panel {
    background-color: #2b5870;
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 64px;
    width: 320px;
    z-index: 400000001;
    display: flex;
    flex-direction: column;
	transition: margin-left 100ms linear;
}

.is-mobile .panel {
	left: -100%;
	width: calc(100% - 52px);
	transition: none;
	top: 0px;
	transition: left 100ms linear;
    box-shadow: 0 7px 29px 0 rgba(100, 100, 111, .2);
}

.is-mobile .panel.is-show {
	left: 52px;
}

.links {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: flex-end;
    padding: 10px 10px 10px 5px;
}

.links-item {
	color: #ffffff;
	font-weight: 400;
	font-size: 12px;
	padding: 0px 5px;
	flex-shrink: 0;
}

.links-item.is-bgg {
	text-align: right;
	flex-grow: 1;
	padding-right: 24px;
	background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAmCAMAAADtLHsqAAAAhFBMVEUAAAD/UQD/UQD/UAD/VwD/UQD/UQD/UQD/UQD/UQD/UAD/WAD/UQD/UQD/UAD/UQD/UgD/UAD/UgD/UQD/UQD/UAD/UQD/UAD/UAD/UQD/UAD/UQD/UQD/UAD/UQD/UQD/UAD/UAD/UAD/UAD/UAD/TwD/RwD/UQD/UQD/UQD/UQD/UQDHSOVYAAAAK3RSTlMAj+5vBcP6rUMoFAjnyYJeLyIb+eTi2M+5o6KblIp+d2RcVU40LQz36dWxGXtUPwAAAN9JREFUOMt1k9cWgjAQRBNARATEjvRu2f//P5MAShnu49wTmF0IwxxTHeZ29ibztMzbQ2AS0WMhrFAjRTPNd8mVeoLJC3SX/li/3Cg/ZxrhDsLnDk3Ry2grDuh3QkhlEoSLx12xktvYYFUJFWLlC+Vh1QqVQ6OptUF1V58Gj6WWtDKW5ILHEhw1pBJhGocgMWM3WsFinDAXg+0Ik66u92kLVUClfrY9LF9LBYu4ysAihRSwiGP06rBQnoxRkfE1iWcqkiEocsu6M/MiL14P2aTIeVvtZ6IrsslthvC4v8i+Ki9rOlCl3nQAAAAASUVORK5CYII=');
	background-position: 100% 50%;
	background-repeat: no-repeat;
	background-size: auto 24px;
}

.links-item.is-bgg small {
	opacity: 0.75;
	display: block;
}

.links-item span,
.links-item a {
	cursor: pointer;
}

.links-item span:hover,
.links-item a:hover {
	text-decoration: underline;
}

</style>
